import { render } from "./BackgroundImages.vue?vue&type=template&id=49839ca1&scoped=true&ts=true"
import script from "./BackgroundImages.vue?vue&type=script&lang=ts"
export * from "./BackgroundImages.vue?vue&type=script&lang=ts"

import "./BackgroundImages.vue?vue&type=style&index=0&id=49839ca1&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49839ca1"]])

export default __exports__